import { render, staticRenderFns } from "./ReceiptStats.vue?vue&type=template&id=cfa12c52&"
import script from "./ReceiptStats.vue?vue&type=script&lang=js&"
export * from "./ReceiptStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports